<div class="models-grid" #modelsGrid>
  <div class="model-viewer-card" #viewerCard1>
    <div class="model-header">
      <span class="view-label"
        >{{ "modelViewer.viewerA" | translate }} ({{
          woundDateMap[selectedModel1Notes?.woundId] | date: "dd.MM.yyyy HH:mm"
        }})</span
      >

      <div class="header-actions">
        <div class="scales-group" *ngIf="showScalesControl">
          <div
            class="scale-checkbox"
            [class.checked]="selectedViewerForScales === 'viewer1'"
            (click)="toggleScaleSelection('viewer1')"
          >
            <i
              class="fa fa-check"
              *ngIf="selectedViewerForScales === 'viewer1'"
            ></i>
          </div>
          <button
            class="btn btn-outline-primary btn-sm mx-2"
            (click)="openScalesModal('viewer1')"
          >
            {{ "modelViewer.assessments" | translate }}
          </button>
        </div>

        <app-select
          *ngIf="modelsList1.length > 0"
          [(ngModel)]="selectedModel1"
          [items]="modelsList1"
          bindLabel="name"
          bindValue="id"
          (ngModelChange)="onModelChange()"
          [clearable]="false"
          [searchable]="false"
        >
        </app-select>
        <button
          *ngIf="!isViewer1Fullscreen && !isViewer2Fullscreen"
          class="btn btn-icon btn-sm btn-outline-primary ms-2"
          (click)="toggleFullscreen(modelsGrid)"
          [title]="'modelViewer.splitScreenFullscreen' | translate"
        >
          <i class="fa-solid fa-table-columns"></i>
        </button>
        <button
          *ngIf="!isSplitScreenFullscreen"
          class="btn btn-icon btn-sm btn-outline-primary ms-2"
          (click)="toggleFullscreen(viewerCard1)"
          [title]="'modelViewer.fullscreen' | translate"
        >
          <i class="fa-solid fa-expand"></i>
        </button>
      </div>
    </div>
    <div class="viewer-container">
      <app-model-viewer
        *ngIf="selectedModel1Notes"
        [modelUrl]="selectedModel1Notes.url"
        [existingNotes]="selectedModel1Notes"
        (onMarkerCreated)="handleMarkerCreation($event)"
        (onMarkerDeleted)="handleMarkerDeletion($event)"
        (onMarkerUpdated)="handleMarkerUpdated($event)"
      >
        ></app-model-viewer
      >
      <div class="empty-state" *ngIf="!selectedModel1Notes && !isLoading">
        <span>{{ "recordNotFound" | translate }}</span>
      </div>
      <div class="loading-state" *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{
            "modelViewer.loading" | translate
          }}</span>
        </div>
      </div>
      <div class="viewer-metrics-strip" *ngIf="viewer1Metrics && showViewerMetricsStrip">
        <div class="v-badge v-badge-photo" [title]="'modelViewer.surfaceArea' | translate">
          <div class="v-badge-content">
            <i class="fa-solid fa-draw-polygon v-badge-ico"></i>
            <span class="v-badge-val">{{ viewer1Metrics.surfaceAreaCm2 | number:'1.2-2' }}<span class="v-badge-unit"> cm²</span></span>
          </div>
          <div class="steepest-photo-popup" *ngIf="hasSteepestViewImages">
            <div class="photo-box">
              <span class="photo-title">Original</span>
              <img [src]="viewer1Metrics?.steepestViewOriginalPath!" alt="Steepest original view" />
            </div>
            <div class="photo-box">
              <span class="photo-title">Segmented</span>
              <img [src]="viewer1Metrics?.steepestViewSegmentedPath!" alt="Steepest segmented view" />
            </div>
          </div>
        </div>
        <div class="v-badge" [title]="'modelViewer.volume' | translate">
          <div class="v-badge-content">
            <i class="fa-solid fa-cube v-badge-ico"></i>
            <span class="v-badge-val">{{ viewer1Metrics.volumeCm3 | number:'1.2-2' }}<span class="v-badge-unit"> cm³</span></span>
          </div>
        </div>
        <div class="v-badge" [title]="'modelViewer.perimeter' | translate">
          <div class="v-badge-content">
            <i class="fa-solid fa-ruler v-badge-ico"></i>
            <span class="v-badge-val">{{ viewer1Metrics.boundaryLengthMm / 10 | number:'1.2-2' }}<span class="v-badge-unit"> cm</span></span>
          </div>
        </div>
        <div class="v-badge v-badge-gran" [title]="'Granulation'">
          <div class="v-badge-content">
            <i class="fa-solid fa-images v-badge-ico"></i>
            <span class="v-badge-val">{{ mockGranulationPercent }}%<span class="v-badge-unit"> Gran.</span></span>
          </div>
          <div class="gran-popup">
            <p class="gran-title">{{ 'modelViewer.tissueComposition' | translate }}</p>
            <div class="gran-body">
              <svg width="80" height="80" viewBox="0 0 42 42">
                <circle cx="21" cy="21" r="15.9" fill="#111" stroke="#1e1e1e" stroke-width="8"/>
                <circle *ngFor="let seg of pieSegments"
                  cx="21" cy="21" r="15.9" fill="transparent"
                  [attr.stroke]="seg.color"
                  stroke-width="8"
                  [attr.stroke-dasharray]="seg.percent + ' ' + (100 - seg.percent)"
                  [attr.stroke-dashoffset]="seg.dashoffset"
                />
              </svg>
              <div class="gran-legend">
                <div class="gran-legend-item" *ngFor="let seg of pieSegments">
                  <span class="gran-dot" [style.background]="seg.color"></span>
                  <span class="gran-leg-label">{{ 'modelViewer.tissue.' + seg.key | translate }}</span>
                  <span class="gran-leg-pct">{{ seg.percent }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="model-viewer-card" #viewerCard2 *ngIf="activeTab === 'models'">
    <div class="model-header">
      <span class="view-label"
        >{{ "modelViewer.viewerB" | translate }} ({{
          woundDateMap[selectedModel2Notes?.woundId] | date: "dd.MM.yyyy HH:mm"
        }})</span
      >

      <div class="header-actions">
        <div class="scales-group" *ngIf="showScalesControl">
          <div
            class="scale-checkbox"
            [class.checked]="selectedViewerForScales === 'viewer2'"
            (click)="toggleScaleSelection('viewer2')"
          >
            <i
              class="fa fa-check"
              *ngIf="selectedViewerForScales === 'viewer2'"
            ></i>
          </div>
          <button
            class="btn btn-outline-primary btn-sm mx-2"
            (click)="openScalesModal('viewer2')"
          >
            {{ "modelViewer.assessments" | translate }}
          </button>
        </div>

        <app-select
          *ngIf="modelsList2.length > 0"
          [(ngModel)]="selectedModel2"
          [items]="modelsList2"
          bindLabel="name"
          bindValue="id"
          (ngModelChange)="onModelChange()"
          [clearable]="false"
          [searchable]="false"
        >
        </app-select>
        <button
          *ngIf="!isViewer1Fullscreen && !isViewer2Fullscreen"
          class="btn btn-icon btn-sm btn-outline-primary ms-2"
          (click)="toggleFullscreen(modelsGrid)"
          [title]="'modelViewer.splitScreenFullscreen' | translate"
        >
          <i class="fa-solid fa-table-columns"></i>
        </button>
        <button
          *ngIf="!isSplitScreenFullscreen"
          class="btn btn-icon btn-sm btn-outline-primary ms-2"
          (click)="toggleFullscreen(viewerCard2)"
          [title]="'modelViewer.fullscreen' | translate"
        >
          <i class="fa-solid fa-expand"></i>
        </button>
      </div>
    </div>
    <div class="viewer-container">
      <app-model-viewer
        *ngIf="selectedModel2Notes"
        [modelUrl]="selectedModel2Notes.url"
        [existingNotes]="selectedModel2Notes"
        (onMarkerCreated)="handleMarkerCreation($event)"
        (onMarkerDeleted)="handleMarkerDeletion($event)"
        (onMarkerUpdated)="handleMarkerUpdated($event)"
      ></app-model-viewer>
      <div class="empty-state" *ngIf="!selectedModel2Notes && !isLoading">
        <span>{{ "recordNotFound" | translate }}</span>
      </div>
      <div class="loading-state" *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{
            "modelViewer.loading" | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="right-content-pane" *ngIf="activeTab !== 'models'">
    <ng-content></ng-content>
  </div>
</div>
